import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "no-line" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["mgmt", $setup.isMobile ? 'vertical' : 'horizontal']),
    id: "header-nav"
  }, [
    _createElementVNode("nav", null, [
      _createElementVNode("ul", null, [
        _createElementVNode("a", _hoisted_1, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: "no-line",
              to: {name: 'scheduling'}
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", { src: $setup.CanineLogo }, null, 8, _hoisted_2)
              ]),
              _: 1
            }),
            ($setup.isMobile)
              ? (_openBlock(), _createBlock($setup["Hamburger"], {
                  key: 0,
                  opened: $setup.openNav,
                  "onUpdate:opened": _cache[0] || (_cache[0] = ($event: any) => (($setup.openNav) = $event))
                }, null, 8, ["opened"]))
              : _createCommentVNode("", true)
          ])
        ]),
        (!$setup.isMobile || $setup.openNav)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.navMenuRoutes, (item) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: item.path,
                  to: {name: item.name}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("li", _hoisted_3, _toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128)),
              _createElementVNode("a", {
                class: _normalizeClass({'router-link-active': false}),
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openDropdown = true)),
                onMouseleave: _cache[3] || (_cache[3] = ($event: any) => ($setup.openDropdown = false))
              }, [
                _cache[5] || (_cache[5] = _createElementVNode("li", { class: "item account" }, "Account", -1)),
                ($setup.openDropdown)
                  ? (_openBlock(), _createElementBlock("ul", {
                      key: 0,
                      class: "dropdown",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createVNode(_component_router_link, { to: {name: 'account'} }, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createElementVNode("li", null, "Settings", -1)
                        ])),
                        _: 1
                      }),
                      _createElementVNode("a", null, [
                        _createElementVNode("li", { onClick: $setup.logout }, "Logout")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 32)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}